import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import queryString from 'query-string'
import { history } from '../../_redux/_store/history'
import { editScopeList } from '../../_redux/_actions/scopeListAction'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import CancelIcon from '@material-ui/icons/Cancel'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'

export default function EditScopeList({
  open,
  dataToEdit,
  findingRuleID,
  scopeDataString,
  onClose,
}) {
  const [editedScopeNoteText, seteditedScopeNoteText] = useState('')
  const dispatch = useDispatch();
  const queryValues = queryString.parse(history.location.search)
  const {machine_type, hmi_type} = queryValues
  
  //Edit the Scope
  const updateRule = () => {
    dispatch(editScopeList(findingRuleID, scopeDataString, editedScopeNoteText, machine_type,hmi_type))
    onClose()
  }
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{ style: { width: '700px', height: '450px' } }}
    >
      <DialogContent style={{ overflow: 'hidden' }}>
        <Grid item container direction='column' justifyContent='center'>
          <Grid
            container
            direction='row'
            justifyContent='space-between'
            style={{ marginBottom: '2em', marginTop: '1em' }}
          >
            <Grid item>
              <Typography style={{ color: '#52A1C2', fontWeight: 700 }}>
                Edit Note Text
              </Typography>
            </Grid>
            <Grid item>
              <Button onClick={onClose} >
                <CancelIcon style={{ color: '#666666' }} />
              </Button>
            </Grid>
          </Grid>
          <Grid
            item
            style={{ marginBottom: '0.5em' }}
            style={{ marginBottom: '2em' }}
          >
            <TextField
              id='ed_scope'
              label='Scope'
              disabled={true}
              defaultValue={dataToEdit.scope}
              variant='outlined'
              fullWidth
            />
          </Grid>
          <Grid
            item
            style={{ marginBottom: '0.5em' }}
            style={{ marginBottom: '2em' }}
          >
            <TextField
              multiline
              rows={7}
              defaultValue={dataToEdit.note_text}
              id='ed_scope_note_text'
              label='Note Text'
              variant='outlined'
              fullWidth
              onChange={(e) => seteditedScopeNoteText(e.target.value)}
            ></TextField>
          </Grid>
          <Grid container direction='row' style={{ marginBottom: '3em' }}>
            <Grid item>
              <Button
                onClick={() => {
                  updateRule()
                }}
              >
                Done
              </Button>
            </Grid>
            <Grid item>
              <Button onClick={onClose}>Cancel</Button>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  )
}
